import React from 'react'

import './modal.scss'

export default class ModalComponent extends React.Component {

    closeModal = () =>  this.props.close()

    render() {
        const modalStyle = this.props.modalStyle || {}
        const bodyStyle = this.props.bodyStyle || {}
        return (
            <div>
                <div onTouchTap={this.closeModal} className="drop-shadow animated fadeIn" style={{top: 64, height: 'calc(100% - 80px)'}} />
                <div className="modal show animated zoomInS" style={{top: 64, height: 'calc(100% - 80px)'}}>
                    <div className="modal-dialog" style={modalStyle}>
                        <div className="modal-content">
                            <div className="modal-header">
                                <button type="button" className="close" data-dismiss="modal" aria-hidden="true"
                                        onClick={this.closeModal}>

                                    <span className="fa fa-times" />
                                </button>
                                <h3 className="modal-title">{this.props.title}</h3>
                            </div>
                            <div className="modal-body" style={bodyStyle}>
                                {this.props.children || this.props.content}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        )
    }
}



// WEBPACK FOOTER //
// ./src/shared/modal/SimpleModalComponent.jsx